import React from 'react';
import { Row, Col, Button, Breadcrumb } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import BrandTheme from '../../theme/BrandTheme';
import { FaArrowLeft } from 'react-icons/fa';

/**
 * Standard Page Header for the Brand Theme with responsive styling.
 */
const BrandHeader = ({ title, subtitle, icon, actions = [], breadcrumbs = [], showBack = false }) => {
    const navigate = useNavigate();

    return (
        <div className="brand-header mb-3 mb-md-4">
            {/* Optional Breadcrumbs */}
            {breadcrumbs.length > 0 && (
                <Breadcrumb className="mb-2">
                    {breadcrumbs.map((crumb, idx) => (
                        <Breadcrumb.Item
                            key={idx}
                            linkAs={Link}
                            linkProps={{ to: crumb.to }}
                            active={crumb.active}
                        >
                            {crumb.label}
                        </Breadcrumb.Item>
                    ))}
                </Breadcrumb>
            )}

            <Row className="align-items-center g-3 mx-0">
                <Col lg={8} md={7} xs={12}>
                    <div className="d-flex align-items-center">
                        {showBack && (
                            <Button
                                variant="light"
                                className="me-2 me-md-3 shadow-sm rounded-circle p-2 d-flex align-items-center justify-content-center flex-shrink-0"
                                style={{ width: 38, height: 38 }}
                                onClick={() => navigate(-1)}
                            >
                                <FaArrowLeft color={BrandTheme.colors.text.secondary} />
                            </Button>
                        )}

                        {icon && (
                            <div
                                className="text-white p-2 p-md-3 rounded-3 shadow-sm me-2 me-md-3 brand-icon-box d-flex align-items-center justify-content-center flex-shrink-0"
                                style={{
                                    background: BrandTheme.gradients.primary,
                                    width: 46,
                                    height: 46,
                                    fontSize: '1.3rem'
                                }}
                            >
                                {icon}
                            </div>
                        )}
                        <div className="min-w-0">
                            <h3 className="mb-0 fw-bold fs-4 fs-md-3 text-truncate" style={{ color: BrandTheme.colors.primary }}>{title}</h3>
                            {subtitle && <p className="text-muted mb-0 mt-1 small text-truncate-2" style={{ lineHeight: 1.3 }}>{subtitle}</p>}
                        </div>
                    </div>
                </Col>
                <Col lg={4} md={5} xs={12} className="text-start text-md-end">
                    <div className="d-flex align-items-center justify-content-start justify-content-md-end flex-wrap gap-2">
                        {actions.map((action, idx) => (
                            <Button
                                key={idx}
                                variant={action.variant || 'primary'}
                                className="shadow-sm py-2 px-3 flex-grow-1 flex-md-grow-0"
                                onClick={() => action.path ? navigate(action.path) : action.onClick && action.onClick()}
                                style={!action.variant || action.variant === 'primary' ? { background: BrandTheme.colors.primary, border: 'none' } : {}}
                            >
                                {action.icon && <span className="me-2">{action.icon}</span>}
                                {action.label}
                            </Button>
                        ))}
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default BrandHeader;
